export default __webpack_public_path__ + "static/media/EAST2470.34I-34269_-18520_0.b0cde41d.jpg";